export default __webpack_public_path__ + "static/storage_guardian_logo-ac2431fc4ac2aa1644fab9e57105a107.webp";